import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("article", {
    class: "main",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    _withDirectives(_createVNode(_component_PreLoader, null, null, 512), [
      [_vShow, _ctx.preloader]
    ]),
    _withDirectives(_createVNode(_component_router_view, null, null, 512), [
      [_vShow, !_ctx.preloader]
    ])
  ], 4))
}